import { React } from 'react';
import { Flex, Box, Text } from '@chakra-ui/react';

function GreyTextBox({ title, text, textBold = false }) {
  if (!text && text !== 0) return null;

  return (
    <Flex pb='9px'>
      <Box mr='14px'>
        <Text fontWeight='700' textAlign='left' width='fit-content' fontSize='12px'>
          {title}
        </Text>
      </Box>
      <Box>
        <Text fontWeight={`${textBold ? '700' : '400'}`} fontSize='12px'>
          {text}
        </Text>
      </Box>
    </Flex>
  );
}

export default GreyTextBox;
